import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import ThankYou from "./pages/ThankYou";
import PurchaseSuccess from "./pages/PurchaseSuccess";
import PurchaseSuccessPhase2 from "./pages/PurchaseSuccessPhase2";
import Terms from "./pages/Terms";
import Webinar from "./pages/Webinar";
import WebinarRegistered from "./pages/WebinarRegistered";


const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/webinar" element={<Webinar />} />
          <Route path="/webinar-registered" element={<WebinarRegistered />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/purchase-success" element={<PurchaseSuccess />} />
          <Route path="/purchase-success-phase2" element={<PurchaseSuccessPhase2 />} />
          <Route path="/terms" element={<Terms />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
